import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";
import { formatApiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Sparkles, LogIn } from "lucide-react";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await login(email.trim(), password);
      toast.success("Xoş gəldin!");
      navigate("/dashboard");
    } catch (err) {
      if (!err?.response) toast.error("Serverə qoşulmaq olmur — Render backend işləmir və ya REACT_APP_BACKEND_URL/CORS yanlışdır");
      else toast.error(formatApiError(err.response.data?.detail) || `Giriş alınmadı (${err.response.status})`);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen bg-black text-white flex items-center justify-center px-6">
      <div className="w-full max-w-md">
        <Link to="/" className="flex items-center gap-2 mb-10 justify-center" data-testid="logo">
          <div className="w-8 h-8 bg-cyan-500 flex items-center justify-center">
            <Sparkles className="w-5 h-5 text-black" />
          </div>
          <span className="font-heading font-black text-xl tracking-tighter">FORGE<span className="text-cyan-500">.AI</span></span>
        </Link>
        <div className="border border-[#222] bg-[#0a0a0a] p-8 rounded-sm">
          <p className="font-mono text-[10px] uppercase tracking-[0.2em] text-cyan-500 mb-2">Giriş</p>
          <h1 className="font-heading font-black text-3xl tracking-tighter mb-8">Hesabına daxil ol</h1>
          <form onSubmit={submit} className="space-y-5">
            <div className="space-y-2">
              <Label className="text-xs text-zinc-400">Email</Label>
              <Input type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
                placeholder="sen@example.com"
                className="rounded-sm bg-transparent border-[#333] focus:ring-1 focus:ring-cyan-500"
                data-testid="login-email" />
            </div>
            <div className="space-y-2">
              <Label className="text-xs text-zinc-400">Parol</Label>
              <Input type="password" required value={password} onChange={(e) => setPassword(e.target.value)}
                placeholder="••••••••"
                className="rounded-sm bg-transparent border-[#333] focus:ring-1 focus:ring-cyan-500"
                data-testid="login-password" />
            </div>
            <Button type="submit" disabled={busy}
              className="w-full rounded-sm bg-cyan-500 text-black hover:bg-cyan-400 transition-colors font-medium"
              data-testid="login-submit">
              <LogIn className="w-4 h-4 mr-2" /> {busy ? "Yoxlanılır..." : "Daxil ol"}
            </Button>
          </form>
          <p className="text-sm text-zinc-500 mt-6 text-center">
            Hesabın yoxdur? <Link to="/register" className="text-cyan-400 hover:text-cyan-300" data-testid="to-register">Qeydiyyatdan keç</Link>
          </p>
        </div>
      </div>
    </div>
  );
}
